<template>
    <div class="message ai-message">
        <div class="dot"></div>
        <div>
            <div class="markdown-content" v-html="renderMessage(content)"></div>
            <HoverBar :date="date" :message-id="message_id"/>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useMarkdown } from '../composables/useMarkdown';
import HoverBar from '../ui/HoverBar.vue';

defineProps({
    message_id: { type: String, required: true },
    content: { type: String, required: true },
    date: { type: String, required: false }
});

const { renderMessage } = useMarkdown();
</script>

<style lang="scss" scoped>
.message {
    padding: 10px;
    border-radius: 12px;
    font-size: 14px;
    max-width: 80%;
}

.ai-message {
    display: flex;
    gap: 10px;
    padding-left: 0;
    align-self: flex-start;
    width: fit-content;

    .dot {
        min-width: 8px;
        min-height: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: var(--color-blue);
        margin-top: 6px;
        margin-right: 5px;
        margin-left: 5px;
        flex-shrink: 0;
    }

    &:hover :deep(.hover-bar) {
        opacity: 1;
        pointer-events: auto;
    }

    :deep(.markdown-content) {
        line-height: 1.5;

        p {
            margin: 0 0 10px 0;

            &:last-child {
                margin-bottom: 0;
            }
        }

        ul,
        ol {
            margin: 5px 0 10px 20px;
            padding-left: 0;
        }

        li {
            margin-bottom: 5px;
        }

        code {
            background-color: rgba(0, 0, 0, 0.2);
            padding: 2px 4px;
            border-radius: 4px;
            font-family: monospace;
            font-size: 0.9em;
        }

        pre {
            background-color: rgba(0, 0, 0, 0.2);
            padding: 10px;
            border-radius: 6px;
            overflow-x: auto;
            margin: 10px 0;

            code {
                background-color: transparent;
                padding: 0;
            }
        }

        strong {
            font-weight: 600;
            color: var(--color-blue);
        }

        a {
            color: var(--color-blue);
            text-decoration: underline;
        }
    }
}
</style>
